
<template>
   <v-layout>
      <v-flex xs12>
         <v-card>
            <v-toolbar color="red darken-4" dark>
               <!--v-toolbar-side-icon></v-toolbar-side-icon-->
               <v-toolbar-title>{{ title }}</v-toolbar-title>
               <v-spacer></v-spacer>
               <v-text-field v-model="filter" prepend-icon="search" hide-details single-line></v-text-field>
               <v-btn v-if="canAdd" icon ripple @click="add()">
                  <v-icon>add</v-icon>
               </v-btn>
            </v-toolbar>

            <v-list two-line>
               <template v-for="(user, index) in displayedUsers">
                  <v-list-tile avatar ripple @click="selectUser(user.id)" :key="user.id"
                               v-bind:class="{ 'red': user.id == selectedUserId, 'lighten-4': user.id == selectedUserId }">
                     <v-list-tile-action>
                        <v-tooltip bottom>
                           <v-icon v-if="noPasswordUser(user)" color="pink" slot="activator">error</v-icon>
                           <span>L'utilisateur n'a pas encore activé son compte</span>
                        </v-tooltip>
                        <v-badge right color="brown">
                           <span slot="badge" v-if="unreadMessageCount(user.id) > 0">{{ unreadMessageCount(user.id) }}</span>
                        </v-badge>
                     </v-list-tile-action>
                     <v-list-tile-content>
                        <v-list-tile-title>{{ displayName(user) }}</v-list-tile-title>
                        <v-list-tile-sub-title class="grey--text text--darken-4">{{ user.extra.tag }}</v-list-tile-sub-title>
                     </v-list-tile-content>
                     <v-list-tile-action>
                        <v-btn icon ripple @click.stop="userToDelete = clone(user); deleteDialog = true">
                           <v-icon color="grey lighten-1">delete</v-icon>
                        </v-btn>
                     </v-list-tile-action>
                  </v-list-tile>
                  <v-divider v-if="index + 1 < users.length" :key="user.id + '-'"></v-divider>
               </template>
            </v-list>

            <v-card-text v-if="users.length === 0" style="height: 100px;" class="Aligner">
               <v-icon>not_interested</v-icon>
            </v-card-text>
         </v-card>
      </v-flex>

      <v-dialog v-model="deleteDialog" persistent max-width="400">
         <v-card>
            <v-card-title class="headline grey lighten-2">Confirmer</v-card-title>
            <v-card-text>Supprimer {{ displayName(userToDelete) }} ?</v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn color="brown darken-2" flat @click.native="deleteDialog = false; deleteUser(userToDelete)">Supprimer</v-btn>
               <v-btn color="brown darken-2" flat @click.native="deleteDialog = false">Annuler</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

   </v-layout>
</template>


<script>
   import moment from 'moment'
   import _ from 'lodash'
   import config from '@/config'

   export default {

      props: {
         title: {
            type: String,
            default: "Utilisateurs",
         },
         users: Array,
         selectedUserId: Number,
         canAdd: {
            type: Boolean,
            default: true,
         }
      },

      data () {
         return {
            deleteDialog: false,
            userToDelete: {},
            filter: '',
         }
      },

      computed: {
         displayedUsers() {
            let self = this
            let filteredUsers = this.users.filter(function(user) {
               return self.displayName(user).toLowerCase().indexOf(self.filter.toLowerCase()) !== -1 ||
                  user.username.toLowerCase().indexOf(self.filter.toLowerCase()) !== -1 ||
                  user.extra.tag && user.extra.tag.toLowerCase().indexOf(self.filter.toLowerCase()) !== -1
            })
            let sortedUsers = filteredUsers.sort(function(a, b) {
               if (self.displayName(a).toLowerCase() < self.displayName(b).toLowerCase()) {
                  return -1
               } else if (self.displayName(a).toLowerCase() > self.displayName(b).toLowerCase()) {
                  return 1
               } else {
                  return 0
               }
            })
            return sortedUsers
         },
      },

      methods: {
         clone (user) {
            return _.clone(user)
         },
         selectUser (userId) {
            //this.filter = ''
            this.$emit('userSelected', userId)
         },
         birthDescription (user) {
            return user.birthdate ? "Né le " + moment(user.birthdate).format("DD/MM/YYYY") : ''
         },
         displayName (user) {
            if (user) {
               if (user.first_name && user.last_name) {
                  return user.last_name + ' ' + user.first_name
               } else if (user.fullname) {
                  return user.fullname
               } else {
                  return user.username
               }
            } else {
               return ''
            }
         },
         add () {
            this.$emit('addUser')
         },
         deleteUser (user) {
            this.$emit('deleteUser', user.id)
         },
         unreadMessageCount (userId) {
            return this.$store.state.user2unreadMessageCount[userId]
         },
         noPasswordUser(user) {
            return user.password === config.INITIAL_PASSWORD
         },
      },
   };
</script>

<style scoped>
</style


// WEBPACK FOOTER //
// UserList.vue?99bd9d90